import _ from 'lodash';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap, map, catchError, mergeMap, exhaustMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as DialogActions from 'app/dialog/features/dialog.actions';
import * as LastHeroActions from './last-hero.actions';
import * as ActivityActions from 'app/virtual-event/features/activity/activity.actions';
import { VirtualEventService } from '../../services/virtual-event.service';
import { ToastService } from 'app/toast/services/toast.service';
import { ACTIVITY_TYPE } from '../../virtual-event.enums';


@Injectable()
export class LastHeroEffects {

  loadVirtualEventLastHero$ = createEffect(() => {
    return this.actions$.pipe( 
      ofType(LastHeroActions.loadVirtualEventLastHero),
      exhaustMap((action: any) => {
        const { payload, payload: { vEventId, campaign } } = action;
        return this.virtualEventService.getLastHero(vEventId, campaign.id).pipe(
          map(data => LastHeroActions.loadVirtualEventLastHeroSuccess({ data, payload })),
          catchError(error => of(LastHeroActions.loadVirtualEventLastHeroFailure({ error }))))
      })
    );
  });

  loadVirtualEventLastHeroSuccess$ = createEffect(() => {
    return this.actions$.pipe( 
      ofType(LastHeroActions.loadVirtualEventLastHeroSuccess),
      concatMap(({ payload: { vEventId, campaign } }: any) => {
        const action = DialogActions.openDialog({
          payload: {
            name: 'declareLastHero',
            options: {
              size: 'small',
              modalClass:'modal--paybee modal-sm',
              containerClass:'mdb-modal-backdrop-paybee',
              ignoreBackdropClick: true
            },
            initialState: { vEventId, campaign }
          }
        });
        return of(action);
      })
    );
  });

  declareVirtualEventLastHero$ = createEffect(() => {
    return this.actions$.pipe( 
      ofType(LastHeroActions.declareVirtualEventLastHero),
      exhaustMap((action: any) => {
        const { payload: { vEventId, campaign, lastHero } } = action;
        return this.virtualEventService.declareLastHero(vEventId, campaign.id).pipe(
          tap(()=> {
            return this.toastService.show('success', 'Winner Declared', {delay: 1000});
          }),
          map(data => LastHeroActions.declareVirtualEventLastHeroSuccess({ data })),
          catchError(error => of(LastHeroActions.declareVirtualEventLastHeroFailure({ error }))))
      })
    );
  });

  constructor(
    private actions$: Actions,
    private virtualEventService: VirtualEventService,
    private toastService: ToastService
  ) {}

}
